import { Grid } from '@material-ui/core'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { EmptySearchResultComponent } from '../../../components/empty-search-result-component'
import { FilterNonprofits } from '../../../shared/filter-non-profits'
import {
  ApplyType,
  FilterParamsType,
} from '../../../shared/filter/filter.constants'
import { NonProfit } from '../../../components/non-profit'
import { NonProfitCardPlaceholder } from '../../../components/non-profit/non-profit.components/non-profit-card-placeholder'
import { useScreenSize } from '../../../hooks/use-screen-size'
import { Nonprofit } from '../../../models'
import { useNonProfitsComponentStyles } from './non-profits-component.styles'
import { NonProfitsPageProps } from './non-profits-page.constants'
import { PageWrapper } from '../../../components/page-wrapper'
import { BreadcrumbItem } from '../../../components/breadcrumbs'
import { GridItem } from '../../../shared/grid-item'

export const NonProfitsComponent: React.FC<NonProfitsPageProps> = (
  props: NonProfitsPageProps
) => {
  const {
    nonprofits,
    query,
    changeQueryParamsAction,
    loading,
    //firstRender,
    cancelHandler,
    categories,
    isFilterCollapsed,
    changeFilterCollapsedHandler,
  } = props

  const classes = useNonProfitsComponentStyles()
  const { t } = useTranslation()

  const nonprofitBreadcrumbItems: BreadcrumbItem[] = useMemo(
    () => [
      { label: t('header.menu.search'), to: '/search' },
      { label: t('nonprofitCatalog.title') },
    ],
    [t]
  )

  /*Device Type*/
  const screenSize = useScreenSize()

  /*Filter Change Handler*/
  const onFilterChanged = (
    data: FilterParamsType,
    apply?: ApplyType,
    isStartPagingInBegin?: boolean
  ) => {
    changeQueryParamsAction(data, apply, isStartPagingInBegin)
  }

  const categoryNames = nonprofits.map((nonprofit) => {
    const categoryName = categories.find(
      (category) =>
        category.nonprofitCategoryId === nonprofit.nonprofitCategoryId
    )?.name
    return categoryName || ''
  })

  return (
    <PageWrapper
      title={t('nonprofitCatalog.title')}
      displayGoBackButton={false}
      breadcrumbItems={nonprofitBreadcrumbItems}
    >
      <Grid container spacing={1}>
        <Grid item xs={12} lg={3} md={4}>
          <div className={classes.filterContainer}>
            <FilterNonprofits
              searchText={query.searchText}
              categories={categories}
              nonprofitCategoryId={query.nonprofitCategoryId}
              onFilterChanged={onFilterChanged}
              loading={loading}
              cancelHandler={cancelHandler}
              isFilterCollapsed={isFilterCollapsed}
              setFilterCollapsed={changeFilterCollapsedHandler}
              screenSize={screenSize}
            />
          </div>
        </Grid>
        <Grid item xs={12} lg={9} md={8}>
          <Grid container spacing={1}>
            {loading ? (
              <PlaceholderArrayComponent />
            ) : (
              nonprofits.map((item: Nonprofit, key: number) => (
                <GridItem key={key} xxxs={12} xxs={6} xs={6} md={6} lg={4}>
                  <NonProfit
                    {...item}
                    nonprofitCategoryName={categoryNames[key]}
                  />
                </GridItem>
              ))
            )}
            {!nonprofits.length && !loading && (
              <Grid xs={12} item>
                <EmptySearchResultComponent
                  title={t('emptySearchResult.title')}
                  description={t('emptySearchResult.description')}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </PageWrapper>
  )
}

export const PlaceholderArrayComponent: React.FC = () => {
  const placeholderArray = []
  //eslint-disable-next-line
  for (let i = 0; i < 12; i++) {
    placeholderArray.push(
      <GridItem key={i} xxxs={12} xxs={6} xs={6} md={6} lg={4}>
        <NonProfitCardPlaceholder />
      </GridItem>
    )
  }
  return <>{placeholderArray}</>
}
